/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_New_TitleInputs */

const vi_order_new_title = /** @type {(inputs: Order_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn hàng mới`)
};

/**

* @param {Order_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_new_title = /** @type {((inputs?: Order_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_new_title(inputs)
});